import { makeAutoObservable } from "mobx";
import { RootStore } from "./rootStore";
import moment from "moment";

class DateStore {
  rootStore: RootStore;

  _dateRange: [Date, Date];

  dayDuration = 24 * 60 * 60 * 1000;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    const today = new Date();
    const dayDuration = 24 * 60 * 60 * 1000;

    const yesterday = new Date(today.getTime() - dayDuration);

    this._dateRange = [yesterday, today];

    makeAutoObservable(this);
  }

  get dateRange(): [Date, Date] {
    return this._dateRange;
  }

  set dateRange(range: [Date, Date]) {
    this._dateRange = [...range];
  }

  getDateRange(): [Date, Date] {
    return this.dateRange;
  }

  setDateRange(newRange: [Date, Date]) {
    this.dateRange = newRange;
  }

  // Returns the date range as unix timestamp in seconds
  get unixDateRange(): [number, number] {
    return this.dateRange.map((d) => moment(d).unix()) as [number, number];
  }

  get unixYesterdayRange(): [number, number] {
    return this.yesterdayRange().map((d) => moment(d).unix()) as [
      number,
      number,
    ];
  }

  yesterdayRange(): [Date, Date] {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dayDuration = 24 * 60 * 60 * 1000;
    return [new Date(today.getTime() - dayDuration), new Date(today.getTime())];
  }

  totalDays(): number {
    return (
      (this.dateRange[1].getTime() - this.dateRange[0].getTime()) /
      this.dayDuration
    );
  }
}

export default DateStore;
